import { useEffect, useState } from 'react'
import { cancelSubscription_api, deleteCard_api, getCard_api, getPricePlans_api } from 'store/apis'
import { ModalForm } from 'modules/app/styles'
import { Modal, ModalBody, ModalFooter } from 'reactstrap'
import { consoleLog, handleApiError, usePrevious } from 'utils/helpers'
import { ButtonLoader, PageLoader } from 'utils/storageUtils'
import { CustomButton } from 'modules/auth/styles'
import { ReactComponent as CloseIcon } from 'assets/images/icons/close.svg'
import { ReactComponent as SubscriptionSuccessIllustration } from 'assets/images/SubscriptionSuccess.svg'
import { ReactComponent as MovedToFreePlanillustration } from 'assets/images/movedToFreePlanillustration.svg'
import { toast } from 'react-toastify'
import moment from 'moment'
import {
  createSubscription_action,
  fetchInvoices_action,
  toggleCardModal_action,
  toggleCheckoutModal_action,
  toggleInvoicesModal_action,
  toggleSubscriptionSuccessModal_action,
  updateSubcriptionPlan_action,
  getActiveSubscription_action,
  getCompany_action
} from 'store/actions'
import { connect } from 'react-redux'
import Checkout from 'modules/subscription/Checkout'
import CardForm from 'modules/subscription/CardForm'
import UnSubscribed from 'modules/subscription/UnSubscribed'
import Subscribed from 'modules/subscription/Subscribed'
import ResumePlan from 'modules/subscription/ResumePlan'
import InvoicesList from 'modules/subscription/InvoicesList'
import { MoveToFreeOption } from '../styles'

export const BillingSettings = (props) => {
  const { company: _company, is_subscription_loaded, subscription, is_subscribed, fetchInvoices, showInvoicesModal, free_items_limit } = props
  const [plan_loading, set_plan_loading] = useState(false)

  // Subscriptions
  const [yearly, set_yearly] = useState({})
  const [monthly, set_monthly] = useState({})
  const [plan_selected, set_plan_selected] = useState({})
  const [active_users, set_active_users] = useState([])
  const [showConfirmCancelSubscription, set_showConfirmCancelSubscription] = useState(false)
  const [submittingCancellation, set_submittingCancellation] = useState(false)
  const [cancellationOption, set_cancellationOption] = useState('cancelToPeriodEnd')
  const [showFreePlanIllustration, set_showFreePlanIllustration] = useState(false)

  // payment method
  const [isRemovingCard, set_isRemovingCard] = useState(false)
  const [card, set_card] = useState({})
  const [showRemoveCardConfirm, set_showRemoveCardConfirm] = useState(false)
  const prev_is_subscription_loaded = usePrevious(is_subscription_loaded)

  // SET ACTIVE USERS
  useEffect(() => {
    set_active_users(_company.members.filter((m) => m.is_active && m.invite_status !== 'invited'))
  }, [_company.members])

  // GET PLANS AND CARD
  useEffect(() => {
    const getPlans = async () => {
      try {
        set_plan_loading(true)
        const { data } = await getPricePlans_api()
        const _monthly = data.filter((plan) => plan.active && plan.interval === 'month')[0]
        const _yearly = data.filter((plan) => plan.active && plan.interval === 'year')[0]
        let _plan_selected = _monthly
        if (is_subscribed) {
          _plan_selected = subscription.plan
        }
        set_yearly(_yearly)
        set_monthly(_monthly)
        set_plan_selected(_plan_selected)
      } catch (error) {
        handleApiError(error)
      }
      set_plan_loading(false)
    }
    if (is_subscription_loaded && prev_is_subscription_loaded !== is_subscription_loaded) {
      getPlans()
      getCard()
      fetchInvoices()
    }
  }, [prev_is_subscription_loaded, is_subscription_loaded, subscription, is_subscribed, fetchInvoices])

  // Subscription
  const startSubscription = async () => {
    try {
      const data = {
        plan: plan_selected.interval
      }
      if (!is_subscribed) {
        await props.createSubscription(data)
        props.toggleSubscriptionSuccessModal(true)
        setTimeout(() => props.toggleSubscriptionSuccessModal(false), 2000)
      } else if (subscription.plan.interval !== plan_selected.interval) {
        await props.updateSubcriptionPlan(data)
      }

      setTimeout(() => fetchInvoices(), 2000)
    } catch (error) {
      handleApiError(error)
    }
  }
  const submitPlanCancellation = async () => {
    try {
      set_submittingCancellation(true)
      await cancelSubscription_api(subscription.id, cancellationOption === 'cancelNow')
      props.getActiveSubscription()
      props.getCompany()
      set_showConfirmCancelSubscription(false)
      props.toggleCheckoutModal(false)
      if (cancellationOption === 'cancelNow') {
        set_showFreePlanIllustration(true)
        setTimeout(() => set_showFreePlanIllustration(false), 2000)
      } else {
        toast.success('Plan has been scheduled to cancel on current period end.')
      }
      setTimeout(() => fetchInvoices(), 2000)
    } catch (error) {
      handleApiError(error)
    }
    set_submittingCancellation(false)
  }

  // Payment method
  const getCard = async () => {
    try {
      set_card({})
      const data = await getCard_api()
      set_card(data)
    } catch (error) {
      consoleLog(error)
    }
  }
  const toggleRemoveCardModal = (value, e) => {
    e && e.preventDefault()
    set_showRemoveCardConfirm(value)
  }
  const onRemoveCardConfrim = async () => {
    try {
      set_isRemovingCard(true)
      await deleteCard_api(card.id)
      getCard()
      if (!subscription.cancel_at_period_end) {
        await cancelSubscription_api(subscription.id, false)
      }
      props.getActiveSubscription()
      props.getCompany()
      props.toggleCardModal(false)
      set_showRemoveCardConfirm(false)
    } catch (error) {
      handleApiError(error)
    }
    set_isRemovingCard(false)
  }

  return (
    <>
      <ModalBody className='p-0'>
        {plan_loading && <PageLoader />}
        {!plan_loading && (
          <>
            {/* Free */}
            {!props.is_subscribed && <UnSubscribed plan_loading={plan_loading} monthly={monthly} yearly={yearly} plan_selected={plan_selected} set_plan_selected={set_plan_selected} />}
            {/* PRO */}
            {props.is_subscribed && <Subscribed plan_loading={plan_loading} monthly={monthly} yearly={yearly} active_users={active_users} card={card} />}
          </>
        )}
      </ModalBody>

      {/* Remove Card */}
      {showRemoveCardConfirm && (
        <Modal isOpen={true} fade={false} centered toggle={() => toggleRemoveCardModal(false)}>
          <ModalBody>
            <ModalForm>
              <a href='/' className='modal-close' onClick={(e) => toggleRemoveCardModal(false, e)}>
                <CloseIcon />
              </a>
              <div className='title'>Remove Card and Cancel Plan</div>
              {subscription.cancel_at_period_end && <h5 className='font-weight-600 my-5'>Are you sure about removing your card?</h5>}
              {!subscription.cancel_at_period_end && (
                <>
                  <p className='text-danger mt-4'>Are you sure about removing your card? By removing:</p>
                  <p>
                    - your <span className='font-weight-600'>PRO</span> plan will be continued till{' '}
                    <span className='font-weight-600'>
                      {moment
                        .utc(new Date(props.subscription.current_period_end * 1000))
                        .local()
                        .format('ll')}
                    </span>
                    .
                    <br />- No auto-renewals.
                  </p>
                </>
              )}
              <div className='d-flex' style={{ marginTop: 80 }}>
                <CustomButton type='button' className='red btn-sm shadow-none px-4 mr-3' disabled={isRemovingCard} onClick={onRemoveCardConfrim}>
                  Confirm {isRemovingCard && <ButtonLoader />}
                </CustomButton>
                <CustomButton type='button' className='gray btn-sm shadow-none' onClick={() => toggleRemoveCardModal(false)}>
                  Cancel
                </CustomButton>
              </div>
            </ModalForm>
          </ModalBody>
        </Modal>
      )}

      {/* ADD CARD */}
      {props.showCardModal && <CardForm card={card} plan_selected={plan_selected} toggleRemoveCardModal={toggleRemoveCardModal} getCard={getCard} />}

      {props.showCheckoutModal && (
        <Checkout
          set_plan_selected={set_plan_selected}
          plan_selected={plan_selected}
          subscription={subscription}
          monthly={monthly}
          yearly={yearly}
          active_users={active_users}
          get_company={props.get_company}
          card={card}
          startSubscription={startSubscription}
          set_showConfirmCancelSubscription={set_showConfirmCancelSubscription}
        />
      )}

      {props.showResumePlanModal && <ResumePlan card={card} active_users={active_users} />}

      {props.showSubscriptionSuccessModal && (
        <Modal size='sm' isOpen={true} centered fade={false} toggle={() => props.toggleSubscriptionSuccessModal(false)}>
          <ModalBody>
            <a
              href='/'
              className='modal-close'
              onClick={(e) => {
                e.preventDefault()
                props.toggleSubscriptionSuccessModal(false)
              }}>
              <CloseIcon />
            </a>
            <div className='d-flex flex-column align-items-center justify-content-center mb-5'>
              <SubscriptionSuccessIllustration />
              <div className='font-weight-600' style={{ fontSize: 24 }}>
                Welcome to PRO 🎉
              </div>
            </div>
          </ModalBody>
        </Modal>
      )}

      {/* Move To Free */}
      {showConfirmCancelSubscription && (
        <Modal isOpen={true} fade={false} centered toggle={() => set_showConfirmCancelSubscription(false)}>
          <ModalBody style={{ padding: 24 }}>
            <ModalForm>
              <a
                href='/'
                className='modal-close'
                onClick={(e) => {
                  e.preventDefault()
                  set_showConfirmCancelSubscription(false)
                }}>
                <CloseIcon />
              </a>
              <div className='title'>Move to Free</div>
              <div className='mt-5' style={{ marginBottom: 170 }}>
                <MoveToFreeOption className={`mb-4 ${cancellationOption === 'cancelNow' ? 'active' : ''}`} onClick={() => set_cancellationOption('cancelNow')}>
                  <span className='radio'></span>
                  <div className='ml-3'>
                    Move to the free plan <span className='font-weight-600'>immediately</span> (and have credits for the unused days for future upgrades)
                  </div>
                </MoveToFreeOption>
                <MoveToFreeOption className={`mb-4 ${cancellationOption === 'cancelToPeriodEnd' ? 'active' : ''}`} onClick={() => set_cancellationOption('cancelToPeriodEnd')}>
                  <span className='radio'></span>
                  <div className='ml-3'>
                    Move to the free plan when the plan <span className='font-weight-600'>is expired</span> and keep using until then
                  </div>
                </MoveToFreeOption>
              </div>
              {cancellationOption === 'cancelNow' && (
                <ul className='text-danger mb-0 ml-4' style={{ listStyleType: 'disc' }}>
                  <li>You won't have access to your newest docs</li>
                  <li>You'll be limited to {free_items_limit} docs</li>
                </ul>
              )}
            </ModalForm>
          </ModalBody>
          <ModalFooter className='d-flex justify-content-start' onClick={() => submitPlanCancellation()}>
            <CustomButton type='button' className='black' disabled={submittingCancellation}>
              Move to Free {submittingCancellation && <ButtonLoader />}
            </CustomButton>
          </ModalFooter>
        </Modal>
      )}
      {showFreePlanIllustration && (
        <Modal size='sm' isOpen={true} fade={false} centered toggle={() => set_showFreePlanIllustration(false)}>
          <ModalBody style={{ padding: 24 }}>
            <ModalForm>
              <a
                href='/'
                className='modal-close'
                onClick={(e) => {
                  e.preventDefault()
                  set_showConfirmCancelSubscription(false)
                }}>
                <CloseIcon />
              </a>
              <div className='d-flex flex-column align-items-center justify-content-center mb-5'>
                <MovedToFreePlanillustration />
                <div className='font-weight-600' style={{ fontSize: 24 }}>
                  You Are On The Free Plan
                </div>
              </div>
            </ModalForm>
          </ModalBody>
        </Modal>
      )}

      {showInvoicesModal && (
        <Modal isOpen={true} fade={false} centered toggle={() => props.toggleInvoicesModal(false)}>
          <ModalBody>
            <ModalForm>
              <a
                href='/'
                className='modal-close'
                onClick={(e) => {
                  e.preventDefault()
                  props.toggleInvoicesModal(false)
                }}>
                <CloseIcon />
              </a>
              <div className='title'>Invoices</div>
              <InvoicesList invoices={props.invoices} stripe_customer={props.stripe_customer} />
            </ModalForm>
          </ModalBody>
        </Modal>
      )}
    </>
  )
}

const mapStateToProps = (state) => ({
  subscription: state.subscription.subscription,
  is_subscription_loaded: state.subscription.is_subscription_loaded,
  is_subscribed: state.subscription.is_subscribed,
  showCardModal: state.subscription.showCardModal,
  showCheckoutModal: state.subscription.showCheckoutModal,
  showSubscriptionSuccessModal: state.subscription.showSubscriptionSuccessModal,
  showResumePlanModal: state.subscription.showResumePlanModal,
  showInvoicesModal: state.subscription.showInvoicesModal,
  invoices: state.subscription.invoices,
  stripe_customer: state.company.company.stripe_customer,
  free_items_limit: state.company.company.free_items_limit,
})

const mapDispatchToProps = (dispatch) => ({
  createSubscription: (data) => new Promise((resolve, reject) => dispatch(createSubscription_action(data, resolve, reject))),
  updateSubcriptionPlan: (data) => new Promise((resolve, reject) => dispatch(updateSubcriptionPlan_action(data, resolve, reject))),
  getCompany: () => dispatch(getCompany_action()),
  getActiveSubscription: () => dispatch(getActiveSubscription_action()),
  toggleSubscriptionSuccessModal: (value) => dispatch(toggleSubscriptionSuccessModal_action(value)),
  toggleCheckoutModal: (value) => dispatch(toggleCheckoutModal_action(value)),
  toggleCardModal: (value) => dispatch(toggleCardModal_action(value)),
  toggleInvoicesModal: (value) => dispatch(toggleInvoicesModal_action(value)),
  fetchInvoices: () => dispatch(fetchInvoices_action())
})

export default connect(mapStateToProps, mapDispatchToProps)(BillingSettings)
